/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { withRouter, NavLink, useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { confirmationPopupState } from "Components/common/confirmationPopup";
import { TutorialSlider } from "Components/tutorial/TutorialSlider";
import { toasterState } from "Components/common/toaster";
import { teamInvitedStore } from "Stores/TeamInvitedData";
import { onboardingStoreData } from "Stores/onBoardingData";
import userDetail from "Stores/userDetail";
import { MP_EVENT } from "Static/constant";
import {
  getFeatureFlagWithTeam,
  checkTeamStatus,
  fetchConnectedEmails
} from "Utils/commonAPI";
import Utils from "Utils/utils";
import { NAV_ICONS, PinIcon, MoreIcon, ChevronIcon } from "./icons";
import { outboxStoreData } from "Pages/Dashboard/outbox/outboxStore";
import { signalsData } from "Stores/signalsData";
import { agentsData, needsYouCount } from "Stores/agentsData";
import { navCounts } from "./navCounts";
import {
  getRailMark,
  getStatusParts,
  nextSignalsSeen,
  signalsNewCount,
  readPinned,
  writePinned,
  readSignalsSeen,
  writeSignalsSeen,
  createHoverIntent,
  leaveOnNextMove,
  moreMenuTop,
  MORE_OPEN_DELAY_MS,
  MORE_CLOSE_DELAY_MS,
  isPanelOpen
} from "./navBadges";
import {
  NAV_ITEMS,
  buildNav,
  togglePin,
  readPins,
  writePins,
  readCollapsedGroups,
  writeCollapsedGroups,
  toggleGroup
} from "./navModel";
import { onboarding } from "Components/common/Onboarding";
import { ReactComponent as SalesgearLogoIcon } from "../Header/Icons/salesgearLogoText.svg";

const SideBar = () => {
  let location = useLocation();
  const {
    team = {},
    email = "",
    isOnBoardingCompleted = ""
  } = userDetail.userInfo || {};
  const {
    subscriptionPlanId = "",
    taskEnabled = false,
    dialerEnabled = false,
    searchEnabled = false,
    newReportsEnabled = false,
    agentsEnabled = false,
    signalsEnabled = false
  } = userDetail?.userFeatureFlag || {};

  let taskPage = Utils.checkLocationPathname(location.pathname, "/tasks");
  let callPage = Utils.checkLocationPathname(location.pathname, "/calls");
  let dataSearchPage =
    Utils.checkLocationPathname(location.pathname, "/discover") ||
    Utils.checkLocationPathname(location.pathname, "/list-builder");
  let listBuilderPage = Utils.checkLocationPathname(
    location.pathname,
    "/list-builder"
  );
  /* -------- Hotjar Code Starts --------- */

  var userId = email || null;

  window.hj("identify", userId, {
    email
  });

  /* -------- Hotjar Code Ends --------- */

  const [adminTeamUser, setAdminTeamUser] = useState(team);
  const memberId = userDetail?.userInfo?.memberId || "";
  const [hoverOpen, setHoverOpen] = useState(false);
  const [keepOpen, setKeepOpen] = useState(readPinned);
  const [pins, setPins] = useState(() => readPins(memberId));
  const [collapsedGroups, setCollapsedGroups] = useState(readCollapsedGroups);
  const [moreOpen, setMoreOpen] = useState(false);
  const moreTimer = useRef(null);
  const clearMoreTimer = () => {
    if (moreTimer.current) clearTimeout(moreTimer.current);
    moreTimer.current = null;
  };
  // Hovering More opens it; leaving both More and its menu closes it after a short grace.
  const hoverMore = () => {
    clearMoreTimer();
    if (!moreOpen) moreTimer.current = setTimeout(() => setMoreOpen(true), MORE_OPEN_DELAY_MS);
  };
  const leaveMore = () => {
    clearMoreTimer();
    moreTimer.current = setTimeout(() => setMoreOpen(false), MORE_CLOSE_DELAY_MS);
  };
  useEffect(() => clearMoreTimer, []);
  const moreMenuRef = useRef(null);
  // The menu opens level with the More row and runs downwards; when the window is short it
  // slides up just enough to fit, and only scrolls when it is taller than the window.
  useLayoutEffect(() => {
    const nav = navRef.current;
    const menu = moreMenuRef.current;
    const row = nav && nav.querySelector(".navMoreRow");
    if (!moreOpen || !nav || !menu || !row) return;
    menu.style.setProperty("--nav-more-top", `${moreMenuTop(row, nav, menu)}px`);
    // Pinning (or folding a group) while the menu is open moves the More row, so follow it.
  }, [moreOpen, pins, collapsedGroups]); // eslint-disable-line react-hooks/exhaustive-deps
  const navRef = useRef(null);
  const [signalsSeen, setSignalsSeen] = useState(readSignalsSeen);
  const hoverIntent = useRef(null);
  if (!hoverIntent.current) hoverIntent.current = createHoverIntent(setHoverOpen);
  const panelOpen = isPanelOpen(keepOpen, hoverOpen);
  // Keep open makes room for the panel instead of covering the page (rule in _sideNav.scss).
  useEffect(() => {
    document.body.classList.toggle("sgLeftNavKeptOpen", keepOpen);
    return () => document.body.classList.remove("sgLeftNavKeptOpen");
  }, [keepOpen]);
  const [showTutorial, setShowTutorial] = useState(false);
  const notificationFlag = localStorage.getItem("TutotialNotificationClicked");
  const [tutorialNotification, setTutorialNotification] = useState(
    notificationFlag !== "true"
  );
  const [onBoardingFlagValues, setOnBoardingFlagValues] = useState(
    onboardingStoreData.onBoardingFlags
  );
  const [remainigFeatureCount, setRemainingFeatureCount] = useState(0);
  const [isOnboardingCompleted, setOnboardingCompleted] = useState(true);

  const toggleTutorial = () => {
    Utils.mixpanelTrack(MP_EVENT.NAV_TUTORIAL_CLICKED);
    localStorage.setItem("TutotialNotificationClicked", true);
    setTutorialNotification(false);
    setShowTutorial(!showTutorial);
  };

  const acceptInvite = async buttonLoadingFn => {
    try {
      const token = teamInvitedStore?.teamInvitedData?.token;
      const { email: userEmail = "" } = userDetail?.userInfo || {};
      const response = await teamInvitedStore.acceptInvite(userEmail, token);
      buttonLoadingFn(false);
      confirmationPopupState.setShowPopup(false);
      if (response) {
        const respData = response?.data || {};
        if (respData?.status === "success") {
          handleAcceptInviteSuccess();
        } else {
          Utils.showApiFailureResponse(response);
        }
      } else {
        Utils.showApiFailureResponse(response);
      }
    } catch (err) {
      console.error(
        "Team invitation accept error from confirmation popup",
        err
      );
    }
  };

  const updateFeatureFlags = async () => {
    let userData = {};
    let userFlags = await getFeatureFlagWithTeam();
    userData.email = userFlags.email;
    userData.userLoggedIn = true;
    userData.team = await checkTeamStatus();
    userDetail.setUserFeatureFlag(userFlags);
    userDetail.setUserInfo(userData);
  };

  const rejectInvite = async buttonLoadingFn => {
    try {
      const response = await teamInvitedStore.rejectInvite();
      buttonLoadingFn(false);
      confirmationPopupState.setShowPopup(false);
      if (response) {
        const respData = response?.data;
        if (respData && respData?.success) {
          handleRejectInviteSuccess();
        } else {
          Utils.showApiFailureResponse(response);
        }
      } else {
        Utils.showApiFailureResponse(response);
      }
    } catch (err) {
      console.error(
        "Team invitation reject - error from confirmation popup",
        err
      );
    }
  };

  const handleRejectInviteSuccess = () => {
    const {
      adminEmail = "",
      adminFirstName = "",
      adminLastName = ""
    } = teamInvitedStore.teamInvitedData || {};
    updateFeatureFlags();
    toasterState.setToastMsg(
      `You have rejected the invitation to join ${getAdminName(
        adminFirstName,
        adminLastName,
        adminEmail
      )} team`,
      "success"
    );
  };

  const handleAcceptInviteSuccess = () => {
    updateFeatureFlags();
    const {
      adminEmail = "",
      adminFirstName = "",
      adminLastName = ""
    } = teamInvitedStore.teamInvitedData || {};
    toasterState.setToastMsg(
      `You have successfully joined ${getAdminName(
        adminFirstName,
        adminLastName,
        adminEmail
      )} team`,
      "success"
    );
  };

  const triggerInvitedPopup = (invitedDetails = {}) => {
    const {
      memberInvited = false,
      adminFirstName = "",
      adminLastName = "",
      adminEmail = ""
    } = invitedDetails || {};
    if (memberInvited) {
      confirmationPopupState.setPopupValues({
        content: getPopupContent(adminFirstName, adminLastName, adminEmail),
        actionBtnText: "Accept",
        cancelBtnText: "Cancel",
        cancelCbk: rejectInvite,
        callback: acceptInvite,
        cancelLoadingMsg: "Rejecting invitation...",
        loadingMsg: "Accepting invitation..."
      });

      confirmationPopupState.setShowPopup(true);
    }
  };

  const getPopupContent = (
    adminFirstName = "",
    adminLastName = "",
    adminEmail = ""
  ) => {
    return `${getAdminName(
      adminFirstName,
      adminLastName,
      adminEmail
    )} invited you to join their team. Accepting will disconnect your LinkedIn accounts and phone numbers, but your private sequences, templates, and inboxes will be moved to your new team.`;
  };

  const getAdminName = (
    adminFirstName = "",
    adminLastName = "",
    adminEmail = ""
  ) => {
    let adminName = "";
    if (adminFirstName && adminLastName) {
      adminName += `${adminFirstName} ${adminLastName}`;
    } else if (adminFirstName) {
      adminName += adminFirstName;
    } else if (adminLastName) {
      adminName += adminLastName;
    } else if (adminEmail) {
      adminName = adminEmail;
    }
    return adminName;
  };

  const toggleKeepOpen = () => {
    const next = !keepOpen;
    setKeepOpen(next);
    writePinned(next);
    if (!next) hoverIntent.current.cancel();
  };

  const onTogglePin = name => {
    const next = togglePin(pins, name);
    setPins(next);
    writePins(memberId, next);
  };

  const onToggleGroup = id => {
    const next = toggleGroup(collapsedGroups, id);
    setCollapsedGroups(next);
    writeCollapsedGroups(next);
  };

  // Keyboard: focusing a rail icon opens the panel and moves focus to the same item there.
  // Mouse focus is left alone so a quick click on an icon still navigates.
  const focusInPanel = (e, name) => {
    let keyboard = false;
    try {
      keyboard = e.target.matches(":focus-visible");
    } catch (err) {
      keyboard = false;
    }
    if (!keyboard) return;
    hoverIntent.current.now();
    window.requestAnimationFrame(() => {
      const el = navRef.current?.querySelector(`.sideNavPanel [data-nav="${name}"]`);
      if (el) el.focus();
    });
  };

  // Focus anywhere in the rail opens the panel; focus leaving it closes it.
  const onBlur = e => {
    if (!e.currentTarget.contains(e.relatedTarget)) hoverIntent.current.leave();
  };

  const onKeyDown = e => {
    if (e.key !== "Escape") return;
    if (moreOpen) setMoreOpen(false);
    else hoverIntent.current.leave();
  };

  const signalsUnread = signalsData?.unreadCount || 0;
  const onSignalsPage = Utils.checkLocationPathname(location.pathname, "/signals");
  const stoppedAgents = (agentsData?.overview?.agents || []).filter(
    c => c?.state === "FAILING"
  ).length;
  const counts = {
    inboxUnread: outboxStoreData?.unreadOutboxCount,
    signalsUnread,
    signalsNew: signalsNewCount(signalsUnread, signalsSeen),
    tasksToday: navCounts.tasksToday,
    tasksLate: navCounts.tasksLate,
    agentsStopped: agentsEnabled ? stoppedAgents : 0,
    // Same count and words as the agents page header's "Needs you" (approvals, failing, drafts missing their ICP).
    agentsNeedYou: agentsEnabled ? needsYouCount(agentsData?.overview?.agents) : 0
  };

  // Today's gating (agents flag, team admin, pricing) lives in navModel.isItemVisible.
  const nav = buildNav({ agentsEnabled, signalsEnabled, adminTeamUser, subscriptionPlanId }, pins);

  const constructOnboardingData = (flagValues = {}) => {
    const {
      isEmailAccountConnected = false,
      isContactsAdded = false,
      isOnboardingCompleted = false,
      firstSequence = null
    } = flagValues || {};
    const tempFlagObj = {};
    tempFlagObj.isSequenceCreated = firstSequence ? true : false;
    tempFlagObj.isEmailAccountConnected = isEmailAccountConnected;
    tempFlagObj.isContactsAdded = isContactsAdded;
    tempFlagObj.isOnboardingCompleted = isOnboardingCompleted;
    calculateRemainingCount(tempFlagObj);
    setOnBoardingFlagValues(flagValues);
    onboarding.setOnBoardingFlagValues(flagValues);
    setOnboardingCompleted(flagValues.isOnboardingCompleted);
  };

  const calculateRemainingCount = (flagObj = {}) => {
    const { isOnboardingCompleted } = flagObj || {};
    if (flagObj && Object.keys(flagObj)?.length) {
      let remainingCount = Object.values(flagObj).reduce(
        (a, item) => a + (item === false ? 1 : 0),
        0
      );
      if (isOnboardingCompleted === false) {
        remainingCount += 1;
      }
      if (localStorage.getItem("findProspectsClicked")) {
        remainingCount -= 1;
      }
      if (localStorage.getItem("SaveViewContactsClicked")) {
        remainingCount -= 1;
      }
      setRemainingFeatureCount(remainingCount);
      onboarding.setRemainingFeatureCount(remainingCount);
    }
  };

  const getClassByFeatureFlags = () => {
    const discoverRestricted = dataSearchPage && !listBuilderPage && !searchEnabled;
    return (taskPage && !taskEnabled) ||
      (callPage && !dialerEnabled) ||
      discoverRestricted
      ? "adjustZindex"
      : "";
  };

  useEffect(() => {
    if (onboardingStoreData?.onBoardingFlags?.isSequenceCreated != null) {
      constructOnboardingData(onboardingStoreData.onBoardingFlags);
    }
  }, [onboardingStoreData.onBoardingFlags]);

  useEffect(() => {
    fetchConnectedEmails();
    teamInvitedStore.getInvitedDetails();
  }, []);

  useEffect(() => {
    setAdminTeamUser(userDetail?.userInfo?.team);
  }, [userDetail.userInfo]);

  useEffect(() => {
    if (teamInvitedStore?.teamInvitedData?.memberInvited) {
      triggerInvitedPopup(teamInvitedStore?.teamInvitedData);
    }
  }, [teamInvitedStore.teamInvitedData]);

  // Opening Signals (or reading signals) moves the "seen" watermark, which clears the blue dot.
  useEffect(() => {
    const next = nextSignalsSeen(signalsUnread, signalsSeen, onSignalsPage);
    if (next !== signalsSeen) {
      setSignalsSeen(next);
      writeSignalsSeen(next);
    }
  }, [signalsUnread, onSignalsPage]);

  useEffect(() => {
    if (taskEnabled) navCounts.start();
    return () => navCounts.stop();
  }, [taskEnabled]);

  // One background read for the Agents line (stopped agents, approvals); never blocks render.
  useEffect(() => {
    if (agentsEnabled) {
      agentsData.fetchOverview();
      agentsData.fetchApprovalCount();
    }
  }, [agentsEnabled]);

  useEffect(() => () => hoverIntent.current.cancel(), []);

  useEffect(() => {
    setPins(readPins(memberId));
  }, [memberId]);

  useEffect(() => {
    if (!panelOpen) setMoreOpen(false);
  }, [panelOpen]);

  // With the panel kept open, a click elsewhere closes the More menu.
  useEffect(() => {
    if (!moreOpen) return undefined;
    const onDown = e => {
      if (navRef.current && !navRef.current.contains(e.target)) setMoreOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => {
      document.removeEventListener("mousedown", onDown);
      // Closing More (Escape, a click) can pull it out from under the cursor without a mouseleave.
      leaveOnNextMove(document, () => navRef.current, hoverIntent.current.leave);
    };
  }, [moreOpen]);

  // Keeps the Signals badge fresh while the app is open.
  useEffect(() => {
    if (!signalsEnabled) return undefined;
    signalsData.startPolling();
    return () => signalsData.stopPolling();
  }, [signalsEnabled]);

  const renderMark = name => {
    const mark = getRailMark(name, counts);
    if (!mark) return null;
    return mark.kind === "count" ? (
      <span className="railMark railCount" aria-hidden="true">
        {mark.value}
      </span>
    ) : (
      <span className={`railMark railDot ${mark.tone}`} aria-hidden="true" />
    );
  };

  const ariaFor = name => {
    const statusText = getStatusParts(name, counts)
      .map(p => p.text)
      .join(", ");
    const { title } = NAV_ITEMS[name];
    return statusText ? `${title}, ${statusText}` : title;
  };

  // The rail carries the marks; the panel spells them out in words instead.
  const renderIcon = (name, withMark = false) => (
    <span className={`svgIcon icon-${name}`}>
      {NAV_ICONS[name]}
      {withMark && renderMark(name)}
    </span>
  );

  const renderRailItem = name => (
    <NavLink
      key={name}
      to={NAV_ITEMS[name].path}
      activeClassName="selected-path"
      className="railItem"
      aria-label={ariaFor(name)}
      tabIndex={panelOpen ? -1 : 0}
      onFocus={e => focusInPanel(e, name)}
    >
      {renderIcon(name, true)}
    </NavLink>
  );

  const renderStatus = parts =>
    parts.map((p, i) => (
      <React.Fragment key={p.text}>
        {i > 0 && " · "}
        <span className={p.tone}>{p.text}</span>
      </React.Fragment>
    ));

  const renderPanelItem = (name, unpinnable = false) => {
    const { path, title, caption, isNew } = NAV_ITEMS[name];
    const status = getStatusParts(name, counts);
    return (
      <div className="navRow" key={name}>
        <NavLink
          to={path}
          activeClassName="selected-path"
          className="panelItem"
          data-nav={name}
          aria-label={ariaFor(name)}
        >
          {renderIcon(name)}
          <span className="navLabel">
            <span className="navTitleLine">
              <span className="text">
                {title}
                {isNew && <span className="navNewTag">NEW</span>}
              </span>
              {!caption && status.length > 0 && (
                <span className="navStatus">{renderStatus(status)}</span>
              )}
            </span>
            {caption && (
              <span className="navCaption">
                {status.length > 0 ? renderStatus(status) : caption}
              </span>
            )}
          </span>
        </NavLink>
        {unpinnable && (
          <button
            type="button"
            className="navUnpin"
            aria-label={`Unpin ${title} from the sidebar`}
            onClick={() => onTogglePin(name)}
          >
            <PinIcon aria-hidden="true" />
          </button>
        )}
      </div>
    );
  };

  // A collapsed group still shows that something inside wants attention.
  const groupMark = items => {
    const marks = items.map(n => getRailMark(n, counts)).filter(Boolean);
    if (!marks.length) return null;
    const tone = marks.some(m => m.tone === "red") ? "red" : "blue";
    return <span className={`groupDot ${tone}`} aria-hidden="true" />;
  };

  return (
    <>
      <nav
        ref={navRef}
        className={`sideBar ${getClassByFeatureFlags()} ${panelOpen ? "isOpen" : ""} ${keepOpen ? "isPinned" : ""}`}
        aria-label="Main navigation"
        onMouseEnter={hoverIntent.current.enter}
        onMouseLeave={hoverIntent.current.leave}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      >
        {showTutorial && <TutorialSlider close={toggleTutorial} />}
        <div className="salesgearLogoIcon">
          <SalesgearLogoIcon />
        </div>

        {/* Collapsed rail: same order as the panel, thin dividers between groups. */}
        <div className="menuList">
          {renderRailItem(nav.home)}
          {nav.groups.map(g => (
            <React.Fragment key={g.id}>
              <span className="railDivider" aria-hidden="true" />
              {g.items.map(renderRailItem)}
            </React.Fragment>
          ))}
          <span className="railDivider" aria-hidden="true" />
          <button
            type="button"
            className="railItem railMore"
            aria-label="More"
            tabIndex={panelOpen ? -1 : 0}
            onFocus={e => focusInPanel(e, "more")}
            onClick={() => {
              hoverIntent.current.now();
              setMoreOpen(true);
            }}
          >
            <span className="svgIcon">
              <MoreIcon />
            </span>
          </button>
        </div>

        {/* Open panel: an overlay over the rail (no page shift). */}
        <div className="sideNavPanel" aria-hidden={!panelOpen}>
          <div className="panelScroll">
            {renderPanelItem(nav.home)}
            {nav.groups.map(g => {
              const collapsed = !!collapsedGroups[g.id];
              return (
                <div className="navGroup" key={g.id}>
                  <button
                    type="button"
                    className="navGroupHeader"
                    aria-expanded={!collapsed}
                    onClick={() => onToggleGroup(g.id)}
                  >
                    <span>{g.title}</span>
                    {collapsed && groupMark(g.items)}
                    <ChevronIcon name={collapsed ? "chevron_right" : "expand_more"} />
                  </button>
                  {!collapsed && g.items.map(n => renderPanelItem(n, g.id === "pinned"))}
                </div>
              );
            })}
            <div className="navMoreRow" onMouseEnter={hoverMore} onMouseLeave={leaveMore}>
              <button
                type="button"
                className={`panelItem panelMore ${moreOpen ? "isActive" : ""}`}
                data-nav="more"
                aria-expanded={moreOpen}
                aria-haspopup="dialog"
                onClick={() => setMoreOpen(!moreOpen)}
              >
                <span className="svgIcon">
                  <MoreIcon />
                </span>
                <span className="text">More</span>
                <ChevronIcon name="chevron_right" />
              </button>
            </div>
          </div>
          <div className="panelFooter">
            <button
              type="button"
              className="panelItem keepOpenBtn"
              aria-pressed={keepOpen}
              onClick={toggleKeepOpen}
            >
              <PinIcon aria-hidden="true" />
              <span className="text">{keepOpen ? "Let it close" : "Keep open"}</span>
            </button>
          </div>
        </div>

        {moreOpen && (
          <div className="navMoreBridge" aria-hidden="true" onMouseEnter={clearMoreTimer} />
        )}
        {moreOpen && (
          <div
            ref={moreMenuRef}
            className="navMoreMenu"
            role="dialog"
            aria-label="More pages"
            onMouseEnter={clearMoreTimer}
            onMouseLeave={leaveMore}
          >
            <p className="navMoreIntro">
              Everything in Salesgear. Pin what you use to the sidebar.
            </p>
            <ul>
              {nav.more.map(name => {
                const { path, title, desc } = NAV_ITEMS[name];
                const isPinned = pins.includes(name);
                return (
                  <li key={name} className="navMoreItem">
                    <NavLink
                      to={path}
                      activeClassName="selected-path"
                      className="navMoreLink"
                      onClick={() => setMoreOpen(false)}
                    >
                      <span className={`svgIcon icon-${name}`}>{NAV_ICONS[name]}</span>
                      <span className="navLabel">
                        <span className="text">{title}</span>
                        <span className="navCaption">{desc}</span>
                      </span>
                    </NavLink>
                    <button
                      type="button"
                      className={`navPinBtn ${isPinned ? "isPinnedItem" : ""}`}
                      aria-pressed={isPinned}
                      aria-label={isPinned ? `Unpin ${title} from the sidebar` : `Pin ${title} to the sidebar`}
                      onClick={() => onTogglePin(name)}
                    >
                      <PinIcon aria-hidden="true" />
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </nav>
    </>
  );
};

export default withRouter(observer(SideBar));
